import { DialpadService } from './../../../../../projects/shared/src/app/services/dialpad.service';
import { Component, OnInit, AfterContentChecked } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@app/core/loader.service';
import { CampaignService } from '@projects/shared/src/app/services/campaign.service';

@Component({
  selector: 'app-with-auth',
  templateUrl: './with-auth.component.html',
  styleUrls: ['./with-auth.component.scss'],
})
export class WithAuthComponent implements OnInit, AfterContentChecked {
  constructor(
    public campaignService: CampaignService,
    private router: Router,
    public loaderService: LoaderService,
    public dialpadService: DialpadService
  ) {}

  ngOnInit(): void {
    this.dialpadService.isCompact = this.router.url === '/agent/calls/campaign';
    // this.dialpadService.isDraggable = !this.dialpadService.isCompact;
  }

  ngAfterContentChecked() {
    this.dialpadService.isCompact = this.router.url === '/agent/calls/campaign';
    // this.dialpadService.isDraggable = !this.dialpadService.isCompact;
  }
}
